import { injectable } from '@patsnap/tahiti-core/shared/inversify';
import type { FiguresPersistenceService } from '../figures-persistence-service';
import type { SpecificationFigure } from '../../types/specification-figures';

const STORAGE_KEY = 'specification_figures';

@injectable()
export class FiguresPersistenceLocalService implements FiguresPersistenceService {
    async saveFigures(figures: SpecificationFigure[]): Promise<void> {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(figures));
    }

    async loadFigures(): Promise<SpecificationFigure[]> {
        const data = localStorage.getItem(STORAGE_KEY);
        return data ? JSON.parse(data) : [];
    }

    async clearFigures(): Promise<void> {
        localStorage.removeItem(STORAGE_KEY);
    }
}
